<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '~ui/util/tailwind'
import { Primitive, type PrimitiveProps } from 'radix-vue'

import { type ButtonVariants, buttonVariants } from '.'

export interface Props extends PrimitiveProps {
  size?: ButtonVariants['size']
  color?: ButtonVariants['color']
  variant?: ButtonVariants['variant']
  disabled?: boolean
  loading?: boolean
  icon?: string
  iconLeading?: string
  iconTrailing?: string
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  color: 'neutral',
  variant: 'solid',
  as: 'button',
})

const disabled = computed(() => props.disabled || props.loading)
const isIconOnly = computed(() => Boolean(props.icon))
</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :class="cn(buttonVariants({ size, color, variant, aspectSquare: isIconOnly }), props.class)"
    :disabled
  >
    <!-- TODO [DEV-8850] : update icon (include figma in docue icon lib first) -->
    <UiIcon
      v-if="loading"
      name="i-svg-spinners:ring-resize"
      size="1.4em"
    />
    <UiButtonIcon
      v-else-if="iconLeading"
      :size
      :name="iconLeading"
    />
    <slot>
      <UiButtonIcon
        v-if="icon"
        :name="icon"
        :size
      />
    </slot>
    <UiButtonIcon
      v-if="iconTrailing"
      :name="iconTrailing"
      :size
    />
  </Primitive>
</template>
